import { useEffect, useState } from "react";
import CompetitorsPageSpeedDashboardFilter from "./CompetitorsPageSpeedDashboardFilter/CompetitorsPageSpeedDashboardFilter";
import CompetitorsPageSpeedDashboardGraph from "./CompetitorsPageSpeedDashboardGraph/CompetitorsPageSpeedDashboardGraph";
import { Divider } from "@mui/material";
import { PsiCompetitors } from "../../../../../logic/MarketPositioning/Scout/CompetitorsPageSpeed/CompetitorsPageSpeedEndPointLogic";
import { trackPromise } from "react-promise-tracker";
import dayjs from "dayjs";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface Props {
  oauthTokenHeader: any;
  selectedSiteUid: any;
}

const CompetitorsPageSpeedDashboard = ({
  oauthTokenHeader,
  selectedSiteUid,
}: Props) => {
  const devices = [{ label: "Mobile" }, { label: "Desktop" }];
  const [selectedGraphType, setSelectedGraphType] = useState(
    "competitor"
  ) as any;
  const [selectedCompetitorCompany, setSelectedCompetitorCompany] = useState(
    []
  ) as any;
  const [selectedCompetitorDomainName, setSelectedCompetitorDomainName] =
    useState([]) as any;
  const [device, setDevice] = useState(devices[0]) as any;
  const [selectedStartDate, setSelectedStartDate] = useState(
    dayjs().startOf("month")
  ) as any;
  const [selectedEndDate, setSelectedEndDate] = useState(
    dayjs().subtract(1, "day")
  ) as any;
  const [loading, setLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [showDashboard, setShowDashboard] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);
  const [exequteQueryContentQuery5, setExequteQueryContentQuery5] = useState(
    []
  ) as any;
  const [exequteQueryContentQuery7, setExequteQueryContentQuery7] = useState(
    []
  ) as any;
  const [exequteQueryContentQuery8, setExequteQueryContentQuery8] = useState(
    []
  ) as any;
  const QUERY_ID_5 = 6299691448795136;
  const QUERY_ID_7 = 5744111122382848;
  const QUERY_ID_8 = 5181161168961536;

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear(); // Full year
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0"); // Day of the month
    return `${year}-${month}-${day}`; // Format: YYYY-MM-DD
  };

  useEffect(() => {
    const fetchAllData = async () => {
      if (selectedStartDate && selectedEndDate && show) {
        setExequteQueryContentQuery5([]);
        setExequteQueryContentQuery7([]);
        setExequteQueryContentQuery8([]);
        try {
          setLoading(true);
          setRefresh(false);
          await Promise.all([
            PsiCompetitors.getCompetitorsDashBoardExecuteQueries(
              oauthTokenHeader,
              setExequteQueryContentQuery5,
              selectedSiteUid,
              formatDate(selectedStartDate),
              formatDate(selectedEndDate),
              QUERY_ID_5,
              device?.label,
              trackPromise
            ),
            PsiCompetitors.getCompetitorsDashBoardExecuteQueries(
              oauthTokenHeader,
              setExequteQueryContentQuery7,
              selectedSiteUid,
              formatDate(selectedStartDate),
              formatDate(selectedEndDate),
              QUERY_ID_7,
              device?.label,
              trackPromise
            ),
            PsiCompetitors.getCompetitorsDashBoardExecuteQueries(
              oauthTokenHeader,
              setExequteQueryContentQuery8,
              selectedSiteUid,
              formatDate(selectedStartDate),
              formatDate(selectedEndDate),
              QUERY_ID_8,
              device?.label,
              trackPromise
            ),
          ]);
        } catch (error) {
          console.error(error);
        } finally {
          if (
            exequteQueryContentQuery5.length > 0 &&
            exequteQueryContentQuery7.length > 0 &&
            exequteQueryContentQuery8.length > 0
          ) {
            // setLoading(false);
          }
          setShow(false);
        }
      } else {
        console.error(
          "Error fetching data",
          "Please select a date range and device to view the dashboard"
        );
      }
    };
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, selectedStartDate, selectedEndDate, device]);

  useEffect(() => {
    if (
      Object.keys(exequteQueryContentQuery5).length > 0 &&
      Object.keys(exequteQueryContentQuery7).length > 0 &&
      Object.keys(exequteQueryContentQuery8).length > 0
    ) {
      setLoading(false);
    }
  }, [
    exequteQueryContentQuery5,
    exequteQueryContentQuery7,
    exequteQueryContentQuery8,
  ]);

  // Separate useEffect for refresh handling
  useEffect(() => {
    if (refresh) {
      const timer = setTimeout(() => {
        setRefresh(false); // Reset refresh after delayed rerun
        setShow(true); // This will trigger the main useEffect
      });
      return () => clearTimeout(timer); // Cleanup to prevent memory leaks
    }
  }, [refresh]);

  return (
    <>
      <CompetitorsPageSpeedDashboardFilter
        setLoading={setLoading}
        devices={devices}
        device={device}
        setDevice={(newDevice: any) => {
          setDevice(newDevice);
          if (!newDevice) {
            // Clear data when device is cleared
            setExequteQueryContentQuery5([]);
            setExequteQueryContentQuery7([]);
            setExequteQueryContentQuery8([]);
            setDisplay(false);
          }
        }}
        selectedSiteUid={selectedSiteUid}
        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedEndDate={setSelectedEndDate}
        showDashboard={showDashboard}
        setShowDashboard={setShowDashboard}
        selectedGraphType={selectedGraphType}
        setSelectedGraphType={setSelectedGraphType}
        exequteQueryContentQuery7={exequteQueryContentQuery7}
        exequteQueryContentQuery8={exequteQueryContentQuery8}
        selectedCompetitorCompany={selectedCompetitorCompany}
        setSelectedCompetitorCompany={setSelectedCompetitorCompany}
        selectedCompetitorDomainName={selectedCompetitorDomainName}
        setSelectedCompetitorDomainName={setSelectedCompetitorDomainName}
        display={display}
        show={show}
        setShow={setShow}
        setDisplay={setDisplay}
      />
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {selectedStartDate &&
            selectedEndDate &&
            device &&
            Object.keys(exequteQueryContentQuery5).length !== 0 &&
            Object.keys(exequteQueryContentQuery7).length !== 0 &&
            Object.keys(exequteQueryContentQuery8).length !== 0 &&
            display &&
            !loading && (
              <>
                <Divider />
                <CompetitorsPageSpeedDashboardGraph
                  exequteQueryContentQuery5={exequteQueryContentQuery5}
                  exequteQueryContentQuery8={exequteQueryContentQuery8}
                  exequteQueryContentQuery7={exequteQueryContentQuery7}
                  loading={loading}
                  selectedCompetitorCompany={selectedCompetitorCompany}
                  setSelectedCompetitorCompany={setSelectedCompetitorCompany}
                  selectedCompetitorDomainName={selectedCompetitorDomainName}
                  setSelectedCompetitorDomainName={
                    setSelectedCompetitorDomainName
                  }
                  selectedGraphType={selectedGraphType}
                />
              </>
            )}
        </>
      )}
    </>
  );
};

export default CompetitorsPageSpeedDashboard;
